export default {
  zh: {
    ApprovalIteminfo: '审批项信息',
    Normalstatus: '正常',
    linenormals: '正常（可添加、可沟通）',
    fbnormals: '正常（有主页、有粉丝）',
    fbtitle: 'FaceBook是否正常',
    fbnopage:'无主页',
    fbhavepagenofans:'有主页，无粉丝',
    IDPhotonormal: '证件照片是否正常',
    LackIDCardOrNoPhoto: '缺少身份证或者无照片',
    IDCardNearExpiration: '身份证接近过期',
    IDCardExpired: '身份证已经过期',
    IDCardphotoForgery: '身份证照片伪造',
    PhotocopyIDCard: '复印身份证',
    IDCardForgery: '身份证伪造',
    DamagedIDCard: '破损身份证',
    MyIDCardDoesntMatchMe: '身份证与本人不匹配',
    IDCardPhotoIsPasted: '身份证照片是粘贴的',
    IDCardPhotoIsNotClear: '身份证照片不清晰',
    IDCardIsNotClear: '身份证不清晰',
    IDCardPhotoIsTooDark: '身份证照片太暗',
    IDCardPhotoIsIncomplete: '身份证照片不全',
    fontOfIDCardIsDifferentFromNormal: '身份证字体与正常不同',
    typesettingOfIDCardIsInclined: '身份证排版倾斜',
    NoSignatureOnTheIDCard: '身份证上无签名',
    OthersValue: '其他',


    livingBodyNormal: '活体是否正常',
    livingphotoDoesntMatchIDCard: '活体照片与身份证不匹配',


    ContactInformationNormal: '联系人信息是否正常',
    ContactNameException: '联系人姓名异常',
    ContactPhoneException: '联系人电话无法接通',
    LackConnections: '缺少联系人',
    linenormal: 'LINE是否正常', //LINE ปกติมั้ย?  Is LINE normal?
    Sensitiveoccupation: '敏感职业',//Sensitive occupation อาชีพที่ละเอียดอ่อน
    yesSensitiveoccupation: '是敏感职业',
    noSensitiveoccupation: '非敏感职业',
    fou: '否',
    shi: '是',
    Unabletoadd: '无法添加',//ไม่สามารถเพิ่มได้   Unable to add


    phoneAnsweredProperly: '本人电话接听是否正常',
    PhoneNumError: '电话号码不正确',
    cantAnswerPhone: '接不通电话',
    PhoneEmpty: '电话为空',
    phoneNumIsntMyOwn: '电话号码不是本人的',
    IDidntAnswerThePhone: '接听电话非本人',
    NonpersonalVerificationInfo: '非本人验证信息',
    CustomerRequestsCloseOrder: '客户请求关闭订单',
    CustomerDoesntAcknowledgeOrder: '客户不承认此订单',
    RemarkValue: '备注',
    submitValue: '提交',
    pendingReview: '待复审',
    inputRemark: '请输入备注内容',
    isinsatll:'是否安装信审 APP',
    isinsatllyes:'有安装',
    isinsatllno:'无安装',
    insatllpartone:'（ 共有 ',
    insatllparttwo:' 条记录 ）',
    refresh:'刷新',


    /*点击电话的备注弹框*/
    // 不接电话情况
    NotAnsweringCall: '不接电话情况',
    turnOff: '本人关机',
    leaveSms: '本人留言服务',
    turnOfftwo: '联系人关机',
    leaveSmstwo: '联系人留言服务',
    invalidNumber: '无效号码、错误号码',
    notAnswering: '不接电话',
    doNotContacted: '不想再被联系',
    doNotKnowBorrower: '联系人不认识用户',
    // 接电话情况
    ReceivingCall: '接电话情况',
    HeIsAFatherl: '男 接电话，是爸爸',
    SheIsAMother: '女 接电话，是妈妈',
    SheIsAWife: '女 接电话，是妻子',
    HeIsAHusband: '男 接电话，是丈夫',
    olderBrotherYoungerBrother: '男 接电话 兄弟、弟弟、姐夫、姐夫',
    olderSisterYoungerSisterAunt: '女 接电话 姐姐、妹妹、阿姨、亲戚',
    heWorkmate: '男 接电话 朋友、同事',
    SheWorkmate: '女 接电话 朋友、同事',
    NotConfirmRlationship: '接电话，不认识用户',
    ReceiveDisconnect: '接了在挂断电话，再打也不接了',
    Askdone: '不回答认不认识用户，只问用户去做什么？',
    ThoughtScammer: '接电话，可是认为我们是骗子',
    //不认识用户情况
    Notification: '不认识用户情况',
    HeDoesntKnowBorrower: '男 接电话、不认识用户',
    SheDoesntKnowBorrower: '女 接电话、不认识用户',
    NotBeenInTouchWithBorrower: '认识用户、可是好久了没有联系',

    //用户情况
    Borrower: '用户情况',
    ConfirmIdentityIsCorrect: '客户接电话、确认是自己',
    NotAnsweringTheCall: '用户不接电话',
    //关机
    InvalidNumberCloseService: '号码错误，服务已关闭',
    NotBorrower: '不是用户'
    //留言服务
  },
  ti: {
    pendingReview: 'รอการพิจารณาอีกครั้ง',
    ApprovalIteminfo: 'ข้อมูลรายการอนุมัติ',
    Normalstatus: 'ปกติ',
    linenormals: 'ปกติ (สามารถเพิ่มและติดต่อสื่อสารได้)',
    fbnormals: 'ปกติ (มีหน้าโปรไฟล์และมีผู้ติดตาม)',
    fbtitle: 'Facebook ใช้งานได้ปกติหรือไม่?',
    fbnopage:'ไม่มีหน้าโปรไฟล์',
    fbhavepagenofans:'มีหน้าโปรไฟล์แต่ไม่มีผู้ติดตาม',
    IDPhotonormal: 'รูปถ่ายบัตรประชาชนอยู่ในสภาพปกติหรือไม่',
    LackIDCardOrNoPhoto: 'บัตรประชาชนหายบางส่วนไปหรือไม่มีรูปถ่าย',
    IDCardNearExpiration: 'บัตรประชาชนกำลังจะหมดอายุ',
    IDCardExpired: 'บัตรประชาชนประชาชนหมดอายุแล้ว',
    IDCardphotoForgery: 'การปลอมแปลงรูปถ่ายบนบัตรประชาชน',
    PhotocopyIDCard: 'สำเนาบัตรประชาชนประชาชน',
    IDCardForgery: 'การปลอมบัตรประชาชนประชาชน',
    DamagedIDCard: 'บัตรประชาชนประชาชนเสียหาย',
    MyIDCardDoesntMatchMe: 'บัตรประชาชนไม่ตรงกับข้อมูล',
    IDCardPhotoIsPasted: 'ติดรูปภาพบนบัตรประชาชน',
    IDCardPhotoIsNotClear: 'รูปถ่ายบัตรประชาชนไม่ชัดเจน',
    IDCardIsNotClear: 'บัตรประชาชนไม่ชัดเจน',
    IDCardPhotoIsTooDark: 'ภาพถ่ายติดบัตรมืดเกินไป',
    IDCardPhotoIsIncomplete: 'รูปถ่ายบัตรประชาชนที่ไม่สมบูรณ์',
    fontOfIDCardIsDifferentFromNormal: 'แบบอักษรของบัตรประชาชนแตกต่างจากปกติ',
    typesettingOfIDCardIsInclined: 'เค้าโครงบัตรประชาชนเอียง',
    NoSignatureOnTheIDCard: 'ไม่มีลายเซ็นบนบัตรประชาชนประชาชน',
    OthersValue: 'อื่น',


    livingBodyNormal: 'รูปถ่ายยืนยันตัวตนตรงกับบัตรประชาชนหรือไม่',
    livingphotoDoesntMatchIDCard: 'รูปถ่ายยืนยันไม่ตรงกับบัตรประจำตัวประชาชน',


    ContactInformationNormal: 'ข้อมูลการติดต่อเป็นปกติหรือไม่',
    ContactNameException: 'ชื่อผู้ติดต่อไม่ถูกต้อง',
    ContactPhoneException: 'ไม่สามารถติดต่อหมายเลขโทรศัพท์ของผู้ติดต่อได้',
    LackConnections: 'ไม่มีหมายเลขอ้างอิงผู้ติดต่อ',
    linenormal: 'LINE ปกติมั้ย?',
    Sensitiveoccupation: 'อาชีพที่ละเอียดอ่อน',
    yesSensitiveoccupation: 'มันเป็นอาชีพที่ละเอียดอ่อน',
    noSensitiveoccupation: 'อาชีพที่ไม่ละเอียดอ่อน',
    fou: 'เลขที่',
    shi: 'ใช่',
    Unabletoadd: 'ไม่สามารถเพิ่มได้',


    phoneAnsweredProperly: 'รับสายเองว่าปกติหรือไม่',
    PhoneNumError: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    cantAnswerPhone: 'ไม่สามารถติดต่อได้',
    PhoneEmpty: 'ไม่มีหมายเลขโทรศัพท์',
    phoneNumIsntMyOwn: 'หมายเลขโทรศัพท์ไม่ใช่ของผู้ขอสินเชื่อ',
    IDidntAnswerThePhone: 'ผู้ที่รับสายไม่ใช่คนที่ต้องการโทรหา',
    NonpersonalVerificationInfo: 'ข้อมูลการตรวจสอบที่ไม่ใช่ข้อมูลส่วนบุคคล',
    CustomerRequestsCloseOrder: 'ลูกค้าขอปิดบัญชี',
    CustomerDoesntAcknowledgeOrder: 'ลูกค้าปฏิเสธคำขอกู้สินเชื่อ',
    RemarkValue: 'โน้ต',
    submitValue: 'ส่ง',
    inputRemark: 'กรุณากรอกหมายเหตุ',
    isinsatll:' ได้ติดตั้งแอปตรวจสอบเครดิตหรือไม่',
    isinsatllyes:'ติดตั้งแล้ว',
    isinsatllno:'ยังไม่ได้ติดตั้ง',
    insatllpartone:'( ทั้งหมด ',
    insatllparttwo:' รายการ )',
    refresh:'รีเฟรช',


    /*点击电话的备注弹框*/
    // 不接电话情况
    NotAnsweringCall: 'กรณีไม่รับสาย',
    turnOff: 'ฉันปิดโทรศัพท์ของฉัน',
    leaveSms: 'บริการข้อความส่วนตัว',
    turnOfftwo: 'ติดต่อปิด',
    leaveSmstwo: 'บริการข้อความติดต่อ',
    invalidNumber: 'เบอร์ไม่ถูกต้อง,หมายเลขไม่ถูกต้อง',
    notAnswering: 'ไม่รับสาย',
    doNotContacted: ' ไม่ต้องการให้ติดต่ออีก',
    doNotKnowBorrower: 'ผู้อ้างอิงแจ้งไม่รู้จักลูกค้า',
    // 接电话情况
    ReceivingCall: 'กรณีรับสาย',
    HeIsAFatherl: 'ช รับสายแจ้งเป็นคุณพ่อ',
    SheIsAMother: 'ญ รับสายแจ้งเป็นคุณแม่',
    SheIsAWife: 'ญ รับสายแจ้งเป็นภรรยา',
    HeIsAHusband: 'ช รับสายแจ้งเป็นสามี',
    olderBrotherYoungerBrother: 'ช รับสายแจ้งเป็นเป็น พี่ชาย,น้องชาย,น้องเขย,พี่เขย',
    olderSisterYoungerSisterAunt: 'ญ รับสายแจ้งเป็นพี่สาว,น้องสาว,น้า,ป้า,ญาติ',
    heWorkmate: 'ช รับสายแจ้งเป็นเพื่อนหรือเพื่อนร่วมงาน',
    SheWorkmate: 'ญ รับสายแจ้งเป็นเพื่อนหรือเพื่อนร่วมงาน',
    NotConfirmRlationship: 'รับสายแต่ไม่ตอบว่ารู้จักลูกค้าหรือไม่',
    ReceiveDisconnect: 'รับแล้วตัดสายติดต่อกับอีกครั้งไม่รับสาย',
    Askdone: ' ไม่ตอบความสัมพันธ์แต่สอบถามกับผู้กู้ไปทําอะไรไว้',
    ThoughtScammer: 'รับสายแล้วและคิดว่าเป็นมิจฉาชีพ',
    //不认识用户情况
    Notification: 'กรณีแจ้งไม่ใช่',
    HeDoesntKnowBorrower: 'ช รับสายแจ้งไม่ใช่ไม่รู้จักลูกค้า',
    SheDoesntKnowBorrower: 'ญ รับสายแจ้งไม่ใช่ไม่รู้จักลูกค้า',
    NotBeenInTouchWithBorrower: 'อ้างอิงรู้จักลูกค้าแต่ไม่ได้ติดต่อนานแล้ว',

    //用户情况
    Borrower: 'กรณีผู้กู้',
    ConfirmIdentityIsCorrect: 'ลูกค้ารับสายยืนยันข้อมูลตัวตนถูกต้อง',
    NotAnsweringTheCall: 'ลูกค้าไม่รับสาย',
    //关机
    InvalidNumberCloseService: 'หมายเลขไม่ถูกต้อง,ปิดบริการ',
    NotBorrower: 'ไม่ใช่ผู้กู้'
    //留言服务
  },
  en: {
    pendingReview: 'Pending review',
    ApprovalIteminfo: 'Approval item information',
    Normalstatus: 'Normal',
    linenormals: 'Normal (can be added and communicated)',
    fbnormals: 'Normal (has a homepage and fans)',
    fbtitle: 'Is FaceBook normal?',
    fbnopage:'No Page',
    fbhavepagenofans:'Has Page, No Followers',
    IDPhotonormal: 'Is the ID photo normal',
    LackIDCardOrNoPhoto: 'Lack of ID card or no photo',
    IDCardNearExpiration: 'The ID card is nearing expiration',
    IDCardExpired: 'The ID card has expired',
    IDCardphotoForgery: 'ID card photo forgery',
    PhotocopyIDCard: 'Photocopy ID card',
    IDCardForgery: 'ID card forgery',
    DamagedIDCard: 'Damaged ID card',
    MyIDCardDoesntMatchMe: 'The ID card does not match with me',
    IDCardPhotoIsPasted: 'The ID photo is pasted',
    IDCardPhotoIsNotClear: 'ID photo is not clear',
    IDCardIsNotClear: 'ID card is not clear',
    IDCardPhotoIsTooDark: 'ID photo is too dark',
    IDCardPhotoIsIncomplete: 'Incomplete ID photo',
    fontOfIDCardIsDifferentFromNormal: 'The font of the ID card is different from normal',
    typesettingOfIDCardIsInclined: 'ID card layout tilted',
    NoSignatureOnTheIDCard: 'There is no signature on the ID card',
    OthersValue: 'Other',


    livingBodyNormal: 'Is the living body normal',
    livingphotoDoesntMatchIDCard: 'Live photo does not match ID card',


    ContactInformationNormal: 'Is the contact information normal',
    ContactNameException: 'Abnormal contact name',
    ContactPhoneException: 'The contact\'s phone number cannot be reached',
    LackConnections: 'Missing contact person',
    linenormal: 'Is LINE normal?',
    Sensitiveoccupation: 'Sensitive occupation',
    yesSensitiveoccupation: "It\'s a sensitive profession",
    noSensitiveoccupation: 'non-sensitive occupations',
    fou: 'No',
    shi: 'Yes',
    Unabletoadd: 'Unable to add',


    phoneAnsweredProperly: 'Is my phone answer normal?',
    PhoneNumError: 'Incorrect phone number',
    cantAnswerPhone: 'Can\'t connect the phone',
    PhoneEmpty: 'Phone is empty',
    phoneNumIsntMyOwn: 'The phone number is not my own',
    IDidntAnswerThePhone: 'Answering the call is not the person you are calling',
    NonpersonalVerificationInfo: 'Non-personal verification information',
    CustomerRequestsCloseOrder: 'Customer requests to close order',
    CustomerDoesntAcknowledgeOrder: 'The customer does not acknowledge this order',
    RemarkValue: 'Remark',
    submitValue: 'Submit',
    inputRemark: 'Please enter the remarks',
    isinsatll:'Whether to install the credit review APP',
    isinsatllyes:'Have installed',
    isinsatllno:'No installation',
    insatllpartone:'(  ',
    insatllparttwo:'  records in total )',
    refresh:'refresh',



    /*点击电话的备注弹框*/
    // 不接电话情况
    NotAnsweringCall: 'Not answering call',
    turnOff: 'I shut down my phone',
    leaveSms: 'Personal message service',
    turnOfftwo: 'Contact shutdown',
    leaveSmstwo: 'Contact message service',
    invalidNumber: 'Invalid number',
    notAnswering: 'Not answering',
    doNotContacted: 'Do not contacted',
    doNotKnowBorrower: 'Do not know borrower',
    // 接电话情况
    ReceivingCall: 'Receiving call',
    HeIsAFatherl: 'He is a father',
    SheIsAMother: 'She is a mother',
    SheIsAWife: 'She is a wife',
    HeIsAHusband: 'He is a husband.',
    olderBrotherYoungerBrother: 'He is an older brother, younger brother, or brother-in-law',
    olderSisterYoungerSisterAunt: 'She is an older sister, younger sister, or aunt.',
    heWorkmate: 'He\'s workmate',
    SheWorkmate: 'She\'s workmate',
    NotConfirmRlationship: 'Not confirm the relationship',
    ReceiveDisconnect: 'Receive and disconnect',
    Askdone: 'Ask what borrower has done',
    ThoughtScammer: 'Thought it\'s a scammer',
    //不认识用户情况
    Notification: 'Notification',
    HeDoesntKnowBorrower: 'He doesn\'t know the borrower',
    SheDoesntKnowBorrower: 'She doesn\'t know the borrower',
    NotBeenInTouchWithBorrower: 'Not been in touch with borrower',

    //用户情况
    Borrower: 'Borrower',
    ConfirmIdentityIsCorrect: 'Confirm their identity is correct',
    NotAnsweringTheCall: 'Not answering the call',
    //关机
    InvalidNumberCloseService: 'Invalid number',
    NotBorrower: 'Not borrower'
    //留言服务

  },
  es: {
    ApprovalIteminfo: 'Información sobre el elemento de aprobación'

  }
}